import type SharedCustomField from '@/types/serializers/SharedCustomField';

export type GroupedCustomField = {
  categoryName: string;
  customFields: SharedCustomField[];
};

/**
 * カスタムフィールドをカテゴリごとにグルーピングする
 */
export function groupCustomFieldsByCategory(
  fields: SharedCustomField[] | undefined
): GroupedCustomField[] {
  if (!fields || fields.length === 0) return [];

  const grouped = fields.reduce(
    (acc, field) => {
      const categoryName = field.custom_category?.name || 'その他';
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(field);
      return acc;
    },
    {} as Record<string, SharedCustomField[]>
  );

  return Object.entries(grouped).map(([categoryName, customFields]) => ({
    categoryName,
    customFields: customFields.sort((a, b) => a.order_number - b.order_number),
  }));
}
